/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowArtExhibitionTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowArtExhibition,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Explore Creative Minds!",
    "Art Awaits!",
    "Let’s Admire Art!",
  ],
  title: "Art Exhibition",
  description: "Organize a delightful art exhibition.",
  longDescription:
    "Gather your friends for an inspiring art exhibition! Choose a date, decide on the artists to feature, and plan activities for the event!",
  emoji: "🖼",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Art Exhibition",
          emoji: "🖼",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the art exhibition?",
          emoji: "📅",
          completeAction: {
            question: "Decide on artists to feature?",
            description:
              "Which artists do we want to showcase at the exhibition?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What artists should we include?",
                emoji: "🎨",
                completeAction: {
                  question: "Decide on activities for the exhibition?",
                  description:
                    "What activities should we include during the exhibition?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What activities should we plan?",
                      emoji: "🎉",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Celebrate Art!",
    outroDescription:
      "Your art exhibition plans are set! Enjoy the creativity!",
  },
};
